export * from './StyledContent'
